export default "__VITE_ASSET__DOn8le3a__"